// export const GRAPHQL_URL = '/graphql';
export const GRAPHQL_URL = 'http://localhost:8080/graphql';